import profilePic from "../Assets/Nicolascardinaux.jpg"; 
// Importamos el video local
import profileVideo from "../Assets/nicoperfil.mp4";

export const profile = {
  name: "Nicolás Cardinaux",
  titles: ["Analista de Sistemas", "Especialista en Datos y Automatización", "Inteligencia Artificial, IA y Soluciones"],
  bio: [
    "Analista de Sistemas especializado en soluciones de IA y Automatización. Mi experiencia se centra en el diseño de motores ETL asíncronos y arquitecturas RAG para optimizar la toma de decisiones gerenciales basadas en datos comprobables.",
    "Integro Inteligencia Artificial y ciberseguridad para potenciar mis desarrollos, enfocándome siempre en arquitecturas limpias, eficientes y escalables.",
    "Mi objetivo es brindar Soluciones: ya sea una app móvil, un sistema web o una automatización compleja, me adapto a lo que el proyecto necesite para resolver problemas reales.",
  ],
  // Usamos el video importado
  video: profileVideo, 
  image: profilePic,
  social: {
    email: "contacto.nicolascardinaux@gmail.com",
    linkedin: "https://www.linkedin.com/in/nicolas-cardinaux/", 
    github: "https://github.com/NicolasCardinaux",
    instagram: "https://www.instagram.com/cardinauxnicolas?igsh=cWxhd3luamsyM25x",
  },
};
